/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SelfRegistrationSubmitPinInput = {
    entityReference: string;
    cellphoneNumber: string;
    pin: string;
    clientMutationId?: string | null;
};
export type SelfRegistrationSubmitPinMutationVariables = {
    input: SelfRegistrationSubmitPinInput;
};
export type SelfRegistrationSubmitPinMutationResponse = {
    readonly selfRegistrationSubmitPin: {
        readonly clientMutationId: string | null;
        readonly token: string;
    } | null;
};
export type SelfRegistrationSubmitPinMutation = {
    readonly response: SelfRegistrationSubmitPinMutationResponse;
    readonly variables: SelfRegistrationSubmitPinMutationVariables;
};



/*
mutation SelfRegistrationSubmitPinMutation(
  $input: SelfRegistrationSubmitPinInput!
) {
  selfRegistrationSubmitPin(input: $input) {
    clientMutationId
    token
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SelfRegistrationSubmitPinPayload",
    "kind": "LinkedField",
    "name": "selfRegistrationSubmitPin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelfRegistrationSubmitPinMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelfRegistrationSubmitPinMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d34d0b81a8482797ae5c8f6ca6fa466",
    "id": null,
    "metadata": {},
    "name": "SelfRegistrationSubmitPinMutation",
    "operationKind": "mutation",
    "text": "mutation SelfRegistrationSubmitPinMutation(\n  $input: SelfRegistrationSubmitPinInput!\n) {\n  selfRegistrationSubmitPin(input: $input) {\n    clientMutationId\n    token\n  }\n}\n"
  }
};
})();
(node as any).hash = '4c88be11f6bbabede6ba2491bbfbaa7e';
export default node;
